import styled from "styled-components";
import { CursorValue } from ".";

export const StyledIcon = styled.div<{
  circularColor?: string;
  iconColor?: string;
  circularBorder?: boolean;
  cursor: CursorValue;
  padding?: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: auto;
  height: auto;
  background: ${(props) =>
    props.circularColor ? props.circularColor : "#E7EFFE"};
  border-radius: 100%;
  border: ${(props) =>
    props.circularBorder ? `2px solid ${props.iconColor || "#4285F4"}` : ""};
  cursor: ${(props) => `${props.cursor}`};
  padding: ${(props) => props.padding};
`;
